<script>
    import Navbar from './navbar.svelte'
    import NavbarIcons from './navbaricons.svelte'
    import QuickNavIcons from './quicknavicons.svelte'
    import CardLabel from './cardlabel.svelte'
    import CardLabelText from './cardlabel_text.svelte'

    export let theme
    export let primary
    // export let secondary

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'home-background-dark.png' : 'home-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <Navbar fill={primary} />
    <NavbarIcons />
    <QuickNavIcons fill={primary} />
    <CardLabel fill={primary} />
    <CardLabelText />
</div>
